module.exports = __webpack_public_path__ + "img/audio.5698936f.png";